import Vue from 'vue';
import VueRouter from 'vue-router';
import Router from 'vue-router';

Vue.use(Router);

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
};
export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '@view/account/index.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/account',
                    component: () => import(/* webpackChunkName: "dashboard" */ '@view/account/index.vue'),
                    meta: { title: '账户' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import('@view/login/Login.vue'),
            meta: { title: '登录', skipAuth: true }
        },
        {
            path: '/phoneLogin',
            component: () => import('@view/login/PhoneLogin.vue'),
            meta: { title: '手机号登录', skipAuth: true }
        },
        {
            path: '/emailLogin',
            component: () => import('@view/login/EmailLogin.vue'),
            meta: { title: '邮箱登录', skipAuth: true }
        },
        {
            path: '/forgetPwd',
            component: () => import('@view/login/ForgetPwd.vue'),
            meta: { title: '忘记密码', skipAuth: true }
        },
        {
            path: '/retrieve',
            component: () => import('@view/login/ForgetPwd.vue'),
            meta: { title: '忘记密码', skipAuth: true }
        },
        {
            path: '/register',
            component: () => import('@view/login/PhoneRegister.vue'),
            meta: { title: '手机号注册页面', skipAuth: true }
        },
        {
            path: '/emailRegister',
            component: () => import('@view/login/EmailRegister.vue'),
            meta: { title: '邮箱注册页面', skipAuth: true }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]

});
